import { Injectable } from '@angular/core';
import {map, switchMap} from "rxjs/operators";
import {MesApiService} from "common-shared";
import {Observable} from "rxjs";
import {getBase64} from "common-shared";

@Injectable({
  providedIn: 'root'
})
export class ExcelDataTransferService extends MesApiService {
  constructor() {
    super('ExcelDataTransfer', 'manufacturing');
  }

  downloadClassificators(ids: string[] = []) {
    return this.http.post(this.getRoute({action: 'ExportClassificators'}), {
      items: ids
    }, {
      observe: 'response',
      responseType: 'blob'
    }).pipe(map(value => {
      return this.getFileNameAndData(value);
    }));
  }

  downloadSpecs(ids: string[] = []) {
    return this.http.post(this.getRoute({action: 'ExportSpecs'}), {
      items: ids
    }, {
      observe: 'response',
      responseType: 'blob'
    }).pipe(map(value => {
      return this.getFileNameAndData(value);
    }));
  }

  uploadClassificators(file: File): Observable<number> {
    return getBase64(file).pipe(switchMap(fileData => {
      return this.addGet<string, number>(
        fileData,
        { action: 'ImportClassificators' }
      ).pipe(map(value => {
        return value.data;
      }));
    }));
  }

  uploadSpecs(file: File): Observable<number> {
    return getBase64(file).pipe(switchMap(fileData => {
      return this.addGet<string, number>(
        fileData,
        { action: 'ImportSpecs' }
      ).pipe(map(value => {
        return value.data;
      }));
    }));
  }
}
